import { render } from "./app-modal-add-package.vue?vue&type=template&id=3392d67e"
import script from "./app-modal-add-package.vue?vue&type=script&lang=js"
export * from "./app-modal-add-package.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/item/app-modal-add-package.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3392d67e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3392d67e', __exports__)) {
    console.log('reload')
    api.reload('3392d67e', __exports__)
  }
  
  module.hot.accept("./app-modal-add-package.vue?vue&type=template&id=3392d67e", () => {
    console.log('re-render')
    api.rerender('3392d67e', render)
  })

}


export default __exports__